<template>
  <div class="form-check">
    <input type="checkbox" :id="id" v-on:change="onChange" :checked="checked" :disabled="disabled"/>
    <label :for="id">{{ label }}</label>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    },
    id: {
      type: String
    },
    checked: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange: function (e) {
      this.$emit('change', e.target.checked);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../stylesheets/variables.scss";

.form-check {
  margin-bottom: $sp-margin-small;
}
[type="checkbox"]:not(:checked),
[type="checkbox"]:checked {
  position: absolute;
  left: -9999px;
}
[type="checkbox"]:not(:checked) + label,
[type="checkbox"]:checked + label {
  position: relative;
  padding-left: $height1 + $sp-margin-smaller;
  cursor: pointer;
}

[type="checkbox"]:not(:checked) + label:before,
[type="checkbox"]:checked + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: -2px;
  width: $height1;
  height: $height1;
  border: 2px solid $black-light2;
  background: $white;
  border-radius: 3px;
}
[type="checkbox"]:checked + label:before {
  border-color: transparent;
}
[type="checkbox"]:not(:checked) + label:after,
[type="checkbox"]:checked + label:after {
  content: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyMCAyMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjAgMjA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRkZGRkZGO30KPC9zdHlsZT4KPHRpdGxlPkNoZWNrYm94PC90aXRsZT4KPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+Cjxwb2x5Z29uIGlkPSJwYXRoLTNfMV8iIGNsYXNzPSJzdDAiIHBvaW50cz0iNy4zLDE1LjkgMywxMS42IDQuNSwxMC4xIDcuMiwxMi44IDE1LjIsNCAxNi44LDUuNSAiLz4KPC9zdmc+Cg==");
  position: absolute;
  top: -2px;
  left: 0;
  width: $height1;
  height: $height1;
  transition: all 0.2s;
  border-radius: 3px;
  background-color: $active;
}
[type="checkbox"]:not(:checked) + label:after {
  opacity: 0;
  transform: scale(0);
}
[type="checkbox"]:checked + label:after {
  opacity: 1;
  transform: scale(1);
}
[type="checkbox"]:disabled:checked + label:after {
  color: #999;
}
[type="checkbox"]:disabled + label {
  color: #aaa;
}
[type="checkbox"]:checked:focus + label:before,
[type="checkbox"]:not(:checked):focus + label:before {
  outline: $link-dark solid 2px;
  outline-offset: 2px;
}
[checkbox-inverse] label {
  color: $white;
}
label:hover {
  color: $black-trans2;
}
[checkbox-inverse] label:hover {
  color: $white-trans4;
}

.form-check[disabled] {
  opacity: 0.25;
  pointer-events: none;
}

@mixin check-size($font-size, $height, $correction) {
  .form-check,
  &.form-check {
    font-size: $font-size;
  }
  [type="checkbox"]:not(:checked) + label,
  [type="checkbox"]:checked + label {
    padding-left: $height + $sp-margin-smaller;
  }
  [type="checkbox"]:not(:checked) + label:before,
  [type="checkbox"]:checked + label:before,
  [type="checkbox"]:not(:checked) + label:after,
  [type="checkbox"]:checked + label:after {
    top: $correction;
    width: $height;
    height: $height;
  }
}
[check-size="xs"] {
  @include check-size($fs-xs, $height00, 0);
}
[check-size="s"] {
  @include check-size($fs-s, $height0, -1px);
}
[check-size="m"] {
  @include check-size($fs, $height1, -2px);
}
[check-size="l"] {
  @include check-size($fs-l, $height2, -3px);
}
</style>



// WEBPACK FOOTER //
// src/components/shared/forms/Checkbox.vue